import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './OE_AttendanceList.html?raw';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import EntityStore from '../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';
import { OrchestraBooking, OrchestraDutyType, OrchestraEmployment } from "./OE_AttendanceListTypes";
import OE_AttendanceListInput from './OE_AttendanceListInput';
import "../../moreCore/UI/Tabbing/PageStack";
import PageStack from '../../moreCore/UI/Tabbing/PageStack';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import { ExpandableSection, ExpandableSectionMarkings, HTMLElementWithExpander } from "../../moreCore/UI/Container/ExpandableSectionTypes";



class OE_AttendanceList extends compose(_uiFrameMixin) {
    templateString: any = template;

    private booking: OrchestraBooking;
    private employmentStore: MdsLax<InstanceType<typeof EntityStore<OrchestraEmployment>>>;
    private availableDutyTypes: Array<OrchestraDutyType> = [];
    private defaultPresentTypeID: string;

    private pagestack: MdsLax<InstanceType<typeof PageStack>>;
    private employmentTableContainer: HTMLElement;

    private inputContainer: HTMLDivElement;

    private dutyTypeMap: Object = {};
    private employmentTable: MdsLax<InstanceType<typeof StaticTable>>;

    private isReadonly: boolean = false;

    private employmentTableRowConfig: StaticTable.RowConfig = {
        attributes: [
            "ref_associate.gDisp_Name_Firstname",
            "ref_vt_duty_type.description",
            "ref_functional_group.description",
            "$presence_confirmation_status",
            "ref_vt_duty_type_actual.description"
        ],
        headings: [
            (this as any).translate("General_Label_Musician"),
            (this as any).translate("General_Label_DutyType"),
            (this as any).translate("General_Label_FunctionalGroup"),
            (this as any).translate("General_Label_SelfCheckin"),
            (this as any).translate("General_Label_ActualDutyType")
        ],
        colNamesInternal: [
            "associate",
            "duty_type",
            "functional_group",
            "confirmation_status",
            "duty_type_actual"
        ],
        bgColors: [
            null,
            "ref_vt_duty_type.coloration",
            "ref_functional_group.coloration",
            null,
            "ref_vt_duty_type_actual.coloration"
        ],

    }

    private employmentTableLayout: StaticTable.Layout = {
        label: "employmentTable",
        name: "employmentTable",
        rows: [(this as any).employmentTableRowConfig]
    }

    private setupTable() {
        this.employmentTable = new StaticTable();
        this.employmentTable.setLayout(this.employmentTableLayout);
        this.employmentTable.setupFromStore(this.employmentStore);
        this.employmentTable.setCyAttribute("OE_AttendanceEmploymentTable");
        this.employmentTable.placeAt(this.employmentTableContainer);
    }

    setup(booking: OrchestraBooking) {
        this.show("dlg", `${this.translate("General_Label_OrchestraEmployments")}`)
        
        if (booking.date_start.getTime() < Date.now()){
            this.setReadonly();
            //den hint brauchst nur einmal, eigentlich keinmal aber was solls
            if (typeof (window as any)["flag_omAttendanceRoHintShows"] != 'boolean'){
                (window as any)["flag_omAttendanceRoHintShows"] = false;
            }
            if ((window as any)["flag_omAttendanceRoHintShows"] == false){
                (window as any)["flag_omAttendanceRoHintShows"] = true;
                this.showToast(
                    this.translate("AttendanceList__UserHint_RoForDatedEntries"),
                    "fas fa-info"
                );
            }
        }
        this.booking = booking;

        this.setupTable();

        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API_OrchestraEmploymentAttendanceList__GetDutyTypes",
            {},
            lang.hitch(this, this._onGetDutyTypesResponse),
            lang.hitch(this, this._onGetDutyTypesError)
        );
    }

    private setReadonly() {
        this.isReadonly = true;
        this.requestContextButtonRemove("save_attendance");
    }

    private _onLoadDataResponse(response: Array<OrchestraEmployment>) {
        this.setTitles(`${this.translate("General_Label_OrchestraEmployments")}: ${this.booking.ev_booking_name}`);

        this.employmentStore.setup(response);
        this.employmentTable.setupFromStore(this.employmentStore);
        this.renderInputs();

        this.StandbyStop();
    }

    private renderInputs(): void {
        let completeList = this.employmentStore.getCurrentCompleteList();
        if (completeList.length) {
            completeList.forEach((employment, index) => {
                let employmentInput = new OE_AttendanceListInput();
                employmentInput.on("changed", lang.hitch(this, this._onInputChange));
                employmentInput.setAvailableDutyTypes(this.availableDutyTypes, this.defaultPresentTypeID);
                employmentInput.setData(lang.clone(employment));
                employmentInput.setReadonly(this.isReadonly);
                employmentInput.placeAt(this.getFunctionalGroupContainer(employment));
                if (index < completeList.length - 1) {

                }
            });
        } else {
            let label = this.UiModder.domConstruct.create("h5", null, this.inputContainer);
            this.UiModder.domClass.add(label, "w3-center");
            label.innerHTML = this.translate("General_Label_NoEmployments");
        }
        
    }

    private expandFirstExpander = true;
    private getFunctionalGroupContainer(employment: OrchestraEmployment): MdsLax<InstanceType<typeof ExpandableSection>> {
        let functionalGroup = employment.ref_functional_group;

        if (this.dutyTypeMap.hasOwnProperty(functionalGroup.ID)) {
            let container: MdsLax<InstanceType<typeof ExpandableSection>> = this.dutyTypeMap[functionalGroup.ID]
            let line = this.UiModder.domConstruct.create("hr", null, container.containerNode);
            return container;
        } else {
            let functionalGroupExpander = new ExpandableSection();

            functionalGroupExpander.setup("", functionalGroup.$Displayname, "medium", null, null, this.expandFirstExpander, ExpandableSectionMarkings.hasContent);
            this.expandFirstExpander = false;

            functionalGroupExpander.placeAt(this.inputContainer);

            this.dutyTypeMap[functionalGroup.ID] = functionalGroupExpander;
            return functionalGroupExpander;

        //    let functionalGroupContainer = this.UiModder.domConstruct.create(
        //        "div",
        //        { order: functionalGroup.order },
        //        this.inputContainer,
        //        functionalGroup.order);

        //    let heading = this.UiModder.domConstruct.create("h3", null, functionalGroupContainer);
        //    heading.innerHTML = functionalGroup.$Displayname;
        //    this.dutyTypeMap[functionalGroup.ID] = functionalGroupContainer;
        //    return functionalGroupContainer;
        }
    }

    private _onInputChange(employment: OrchestraEmployment) {
        this.employmentStore.changeEntry(employment);
    }

    private _onLoadDataError(error) {
        console.error(error);
    }

    private _onGetDutyTypesResponse(response: { dutyTypes: Array<OrchestraDutyType>, defaultPresentTypeID: string }) {
        this.availableDutyTypes = response.dutyTypes;
        this.defaultPresentTypeID = response.defaultPresentTypeID;

        this.RequestManager.callfunction(
            "Webtool_API_OrchestraEmploymentAttendanceList__GetBookingEmployments",
            { bookingID: this.booking.ID },
            lang.hitch(this, this._onLoadDataResponse),
            lang.hitch(this, this._onLoadDataError)
        );


    }

    private _onGetDutyTypesError(error) {
        console.error(error);
    }

    private _onClickSave() {
        this.RequestManager.callfunction(
            "Webtool_API_OrchestraEmploymentAttendanceList__SaveEmploymentsOfBooking",
            { bookingID: this.booking.ID, diffData: this.employmentStore.getDiffData() },
            lang.hitch(this, this._onSaveDataResponse),
            lang.hitch(this, this._onSaveDataError))
    }
    private _onSaveDataResponse(response) {
        this.close();
        this.showToast(this.translate("General_Notification_SaveSuccess"), "fas fa-check");
    }

    private _onSaveDataError(error) {
        console.error(error);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.employmentStore = new EntityStore();

        //this.createDefaultButton("save", lang.hitch(this, this._onClickSave));
        this.addButton(
            "save_attendance",
            this.translate("AttendanceList__LayoutHeader_save"),
            lang.hitch(this, this._onClickSave),
            null,
            "secondaryBG",
            "fas fa-floppy-disk",
            true,
            "secondary",
            true
        );
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(OE_AttendanceList);
